<template>
  <base-page-layout :title="highlightTitlePage" class="pa-3 pb-4">
    <div class="highlights-edit-container">
      <div class="campaign-status">
        <mf-icon fill small :color="getStatusLabel(highlightStatus).color">fiber_manual_record</mf-icon><span>{{ getStatusLabel(highlightStatus).text }}</span>
      </div>

      <mf-stepper :steppers="steppers" :step="step" />

      <highlight-step1 v-if="step === 1" :campaign="campaign" :offer-schedule="offerSchedule" @change-step="changeStepValue" />
      <highlight-step2 v-else @change-step="changeStepValue" />
    </div>
  </base-page-layout>
</template>
<script>
import { highlightOffer } from '../../mixins/highlight-offer'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  name: 'HighlightEdit',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    HighlightStep1: () => import('../components/edit/step1/HighlightStep1.vue'),
    HighlightStep2: () => import('../components/edit/step2/HighlightStep2.vue'),
  },
  mixins: [highlightOffer],
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    offerSchedule: {
      type: Object,
      default: () => ({}),
    },
    isOfferSchedulePermissionActive: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    step: 1,
    steppers: [
      {
        step: 1,
        complete: false,
        stepName: 'Informações do destaque',
        pathName: '',
      },
      {
        step: 2,
        complete: false,
        stepName: 'Aparência do destaque',
        pathName: '',
      },
    ],
  }),
  computed: {
    newHightlight() {
      let path = this.$router.currentRoute.fullPath
      return path.includes('novo')
    },
    highlightTitlePage() {
      if (this.newHightlight) return 'Novo destaque'
      return `${this.highlightStatus === 'FINISHED' ? 'Visualizar' : 'Editar'} destaque`
    },
  },

  methods: {
    getStatusLabel,
    changeStepValue(value) {
      this.step = value
    },
  },
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

::v-deep .warning-message {
  color: #a26100;
}

::v-deep .v-card {
  border-radius: 8px !important;
}

::v-deep .title {
  color: $cinza-d10;
  font-size: 20px;
  font-weight: 700;
  line-height: 120%; /* 24px */
}

.campaign-status {
  display: flex;
  flex-direction: row;
  gap: 2px;
  span {
    color: $cinza-d10;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
  }
}
</style>
